<template>
    <div class="service-report">
        <div class="module-hd">服务报告</div>
        <div class="sub-title">工程师日志</div>
        <ul class="tab-hd">
            <li :class="{on:tabId==item.id}" v-for="(item,index) in tabHd" :key="index" @click="tab(item.id,index)">{{item.name}}</li>
        </ul>
        <div class="table-hd">
            <span class="label">服务日志：</span>
            <div class="table-type">
                <span :class="{on:!isDuration}" @click="isDuration=false">时段</span>
                /
                <span :class="{on:isDuration}" @click="isDuration=true">时长</span>
            </div>
        </div>
        <table class="table">
            <tr>
                <th>工程师</th>
                <th>日期</th>
                <th>时间属性</th>
                <th>出发时间</th>
                <th>工作时间</th>
                <th>返程时间</th>
            </tr>
            <tr v-for="(item,index) in tableData" :key="index">
                <td>{{item.UserName}}</td>
                <td>{{item.WorkLogDate}}</td>
                <td>{{item.DateType}}</td>
                <td>{{isDuration?item.GoTimeHours : item.GoTime}}</td>
                <td>{{isDuration?item.WorkTimeHours : item.WorkTime}}</td>
                <td>{{isDuration?item.BackTimeHours : item.BackTime}}</td>
            </tr>
        </table>
        <!-- <dl class="info-dl">
            <dt class="label">服务单：</dt>
            <dd class="value">
                <template v-for="item in reportFileList">
                    <a v-if="item.FileType==2" href="javascript:void(0)" class="link" :key="item.Id">
                        <img class="pic" :src="item.FileUrl" preview="1" :preview-text="item.FileName" alt="">
                    </a>
                    <a v-if="item.FileType==1" :href="item.FileUrl" class="link" :key="item.Id">
                        <img class="pic" :src="item.IconUrl" alt="">
                    </a>
                </template>
            </dd>
        </dl> -->
        <dl class="info-dl">
            <dt class="label">相关文档：</dt>
            <dd class="value">
                <template v-for="item in fileList">
                    <a v-if="item.FileType==2" href="javascript:void(0)" class="link" :key="item.Id">
                        <img class="pic" :src="item.FileUrl" preview="1" :preview-text="item.FileName" alt="">
                    </a>
                    <a v-if="item.FileType==1" :href="item.FileUrl" class="link" :key="item.Id">
                        <img class="pic" :src="item.IconUrl" alt="">
                    </a>
                </template>
                <template v-if="fileList.length == 0">
                    <p style="line-height: 24px;font-size: 14px;color: #333333;">无</p>
                </template>
            </dd>
        </dl>
        <div class="sub-title">服务报告</div>
        <div class="report-desc" v-html="reportContent"></div>
        <template v-if="costInfo && baseInfosJobType!=8 && IsExist">
            <div class="module-hd">结算</div>
            <ul class="bill">
                <li>
                    <div class="clear">
                        <div class="label">
                            服务费用：
                            <span class="tax">含税：<i class="price">¥{{costInfo.WorkLogAmount | formatPrice}}</i></span>
                        </div>
                        <div class="value">¥{{costInfo.WorkLogAmount_NoTax | formatPrice}}</div>
                    </div>
                </li>
                <li>
                    <div class="clear">
                        <div class="label">
                            其他费用：
                            <span class="tax">含税：<i class="price">¥{{costInfo.OtherTaxAmount | formatPrice}}</i></span>
                        </div>
                        <div class="value">¥{{costInfo.OtherAmount | formatPrice}}</div>
                    </div>
                    <div class="clear remark">
                        <div class="label">备注：</div>
                        <div class="value">{{costInfo.OtherAmountRemark}}</div>
                    </div>
                </li>
                <li>
                    <div class="clear">
                        <div class="label">票证：</div>
                        <div class="value">
                            <template v-for="item in OtherAmountFileList">
                                <a v-if="item.FileType==2" href="javascript:void(0)" class="link" :key="item.Id">
                                    <img class="pic" :src="item.FileUrl" preview="1" :preview-text="item.FileName" alt="">
                                </a>
                                <a v-if="item.FileType==1" :href="item.FileUrl" class="link" :key="item.Id">
                                    <img class="pic" :src="item.IconUrl" alt="">
                                </a>
                            </template>
                            <template v-if="OtherAmountFileList.length == 0">
                                <p style="line-height: 24px;font-size: 14px;color: #333333;">无</p>
                            </template>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="clear">
                        <div class="label">
                            住宿费用：
                            <span class="tax">含税：<i class="price">¥{{costInfo.HousingTaxAmount | formatPrice}}</i></span>
                        </div>
                        <div class="value">¥{{costInfo.HousingAmount | formatPrice}}</div>
                    </div>
                    <div class="clear remark">
                        <div class="label">备注：</div>
                        <div class="value">{{costInfo.HousingPriceRemark}}</div>
                    </div>
                </li>
                <li>
                    <div class="clear">
                        <div class="label">票证：</div>
                        <div class="value">
                            <template v-for="item in HousingAmountFileList">
                                <a v-if="item.FileType==2" href="javascript:void(0)" class="link" :key="item.Id">
                                    <img class="pic" :src="item.FileUrl" preview="1" :preview-text="item.FileName" alt="">
                                </a>
                                <a v-if="item.FileType==1" :href="item.FileUrl" class="link" :key="item.Id">
                                    <img class="pic" :src="item.IconUrl" alt="">
                                </a>
                            </template>
                            <template v-if="HousingAmountFileList.length == 0">
                                <p style="line-height: 24px;font-size: 14px;color: #333333;">无</p>
                            </template>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="clear">
                        <div class="label">
                            交通费用：
                            <span class="tax">含税：<i class="price">¥{{costInfo.PDTaxAmount | formatPrice}}</i></span>
                        </div>
                        <div class="value">¥{{costInfo.PDTrafficAmount | formatPrice}}</div>
                    </div>
                    <div class="clear remark">
                        <div class="label">备注：</div>
                        <div class="value">{{costInfo.TrafficPriceRemark}}</div>
                    </div>
                </li>
                <li>
                    <div class="clear">
                        <div class="label">票证：</div>
                        <div class="value">
                            <template v-for="item in TrafficAmountFileList ">
                                <a v-if="item.FileType==2" href="javascript:void(0)" class="link" :key="item.Id">
                                    <img class="pic" :src="item.FileUrl" preview="1" :preview-text="item.FileName" alt="">
                                </a>
                                <a v-if="item.FileType==1" :href="item.FileUrl" class="link" :key="item.Id">
                                    <img class="pic" :src="item.IconUrl" alt="">
                                </a>
                            </template>
                            <template v-if="TrafficAmountFileList.length == 0">
                                <p style="line-height: 24px;font-size: 14px;color: #333333;">无</p>
                            </template>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="clear">
                        <div class="label">
                            加班费用：
                            <span class="tax">含税：<i class="price">¥{{costInfo.OvertimeAmount | formatPrice}}</i></span>
                        </div>
                        <div class="value">¥{{costInfo.OvertimeAmount_NoTax | formatPrice}}</div>
                    </div>
                    <div class="clear remark">
                        <div class="label">备注：</div>
                        <div class="value">{{costInfo.OvertimeAmountRemark}}</div>
                    </div>
                </li>
                <li>
                    <div class="clear">
                        <div class="label">票证：</div>
                        <div class="value">
                            <template v-for="item in OvertimeAmountFileList ">
                                <a v-if="item.FileType==2" href="javascript:void(0)" class="link" :key="item.Id">
                                    <img class="pic" :src="item.FileUrl" preview="1" :preview-text="item.FileName" alt="">
                                </a>
                                <a v-if="item.FileType==1" :href="item.FileUrl" class="link" :key="item.Id">
                                    <img class="pic" :src="item.IconUrl" alt="">
                                </a>
                            </template>
                            <template v-if="OvertimeAmountFileList.length == 0">
                                <p style="line-height: 24px;font-size: 14px;color: #333333;">无</p>
                            </template>
                        </div>
                    </div>
                </li>
                <!-- <li v-if="costInfo.Subsidy==2">
                    <div class="clear">
                        <div class="label">
                            餐饮费用：
                            <span class="tax">含税：<i class="price">¥{{costInfo.FoodTaxAmount | formatPrice}}</i></span>
                        </div>
                        <div class="value">¥{{costInfo.FoodAmount | formatPrice}}</div>
                    </div>
                    <div class="clear remark">
                        <div class="label">备注：</div>
                        <div class="value">{{costInfo.FoodAmountRemark}}</div>
                    </div>
                </li> 
                <li>
                    <div class="clear">
                        <div class="label">票证：</div>
                        <div class="value">
                            <template v-for="item in costInfo.FoodAmountFileList ">
                                <a v-if="item.FileType==2" href="javascript:void(0)" class="link" :key="item.Id">
                                    <img class="pic" :src="item.FileUrl" preview="1" :preview-text="item.FileName" alt="">
                                </a>
                                <a v-if="item.FileType==1" :href="item.FileUrl" class="link" :key="item.Id">
                                    <img class="pic" :src="item.IconUrl" alt="">
                                </a>
                            </template>
                        </div>
                    </div>
                </li>-->
                <!-- <li>
                    <div class="clear">
                        <div class="label">
                            补助费用：
                            <span class="tax">含税：<i class="price">¥{{costInfo.SubsidyAmount | formatPrice}}</i></span>
                        </div>
                        <div class="value">¥{{costInfo.SubsidyAmount_NoTax | formatPrice}}</div>
                    </div>
                </li>
                <li>
                    <div class="clear">
                        <div class="label">减免费用：</div>
                        <div class="value">¥{{costInfo.DeductAmount | formatPrice}}</div>
                    </div>
                </li> -->
                <li>
                    <div class="clear">
                        <div class="label">增补/扣除：</div>
                        <div class="value">{{costInfo.SupplementDeduct}}</div>
                    </div>
                </li>
                <li>
                    <div class="clear">
                        <div class="label">票证：</div>
                        <div class="value">
                            <template v-for="item in TicketAmountFileList">
                                <a v-if="item.FileType==2" href="javascript:void(0)" class="link" :key="item.Id">
                                    <img class="pic" :src="item.FileUrl" preview="1" :preview-text="item.FileName" alt="">
                                </a>
                                <a v-if="item.FileType==1" :href="item.FileUrl" class="link" :key="item.Id">
                                    <img class="pic" :src="item.IconUrl" alt="">
                                </a>
                            </template>
                            <template v-if="TicketAmountFileList.length == 0">
                                <p style="line-height: 24px;font-size: 14px;color: #333333;">无</p>
                            </template>
                        </div>
                    </div>
                </li>
            </ul>
        </template>
        <template v-if="baseInfosJobType!=8 && IsExist">
            <div class="cost-info">
                <div class="item" v-if="addCostInfo.CouponAmount>0">
                    <span class="label">{{addCostInfo.CouponAmountName}}：</span>
                    <span class="value price">-¥{{addCostInfo.CouponAmount  | formatPrice}}</span>
                </div>
                <div class="item">
                    <span class="label">总费用：</span>
                    <span class="value price">¥{{addCostInfo.TotalAmount | formatPrice}}</span>
                </div>
                <div class="item">
                    <span class="label">已付押金：</span>
                    <span class="value price">¥{{addCostInfo.PayedDeposit | formatPrice}}</span>
                </div>
            </div>
            <div class="total" v-if="addCostInfo.DifferStatus==2">
                需额外支付: <span class="price">¥{{addCostInfo.TobePayAmount | formatPrice}}</span>
            </div>
            <div class="total" v-if="addCostInfo.DifferStatus==1">
                待退款: <span class="price">¥{{addCostInfo.TobePayAmount | formatPrice}}</span>
            </div>
        </template>
        <template v-if="baseInfosJobStep<70 && IsExist">
            <div class="btn-primary" @click="baseInfosJobType!=8?confirmReport():jobType8ConfirmReport()">{{baseInfosJobType!=8?'确认并支付':'确认'}}</div>
        </template>
    </div>
</template>
<script>
import {GetJobServiceReport,ConfirmInternalJobServiceReport,SubmitJobServiceCommend} from '@/scripts/api.js'
// import myDialog from "@/components/gkDialog.vue";
// import Stars from '@/components/stars.vue'
export default {
    // components:{
        // Stars,
        // myDialog
    // },
    props:{
        baseInfo:null,
    },
    data(){
        return{
            jobNo:'',
            tabHd:[{id:0,name:'全部'}],
            tabId:0,
            serviceLogList:[],//全部服务日志
            docList:[],//相关文档
            serviceOrderList:[],//服务单
            costInfo:{},
            serviceContent:'',
            isDuration:false,//是否时段
            engineerReportList:[],
            isSelf:false,
            showEvaluate:false,
            behavior:0,//行为举止
            skill:0,//技能水平
            service:0,//服务质量
            supaiService:0,//速派服务质量
            jobAmountVO: [],//每个工程师的费用明细
            addCostInfo:{},     //全部
            isEvaluate: false,  //是否评价过
            baseInfosJobType: 0, //jobType
            baseInfosJobStep: 0,//工单状态

            OtherFileList: [],      //其他票据
            HousingFileList:[],     //住宿票据
            TrafficFileList:[],     //交通票据
            OvertimeFileList:[],    //加班票据
            TicketFileList:[],      //补助票据

            IsExist: true


        }
    },
    computed: {
        userInfo(){
            return this.$store.state.userInfo;
        },
        //表格显示的日志
        tableData(){
            if(this.tabId==0){
                return this.serviceLogList
            }else{
                var arr=[];
                for (let i = 0; i < this.serviceLogList.length; i++) {
                    if(this.serviceLogList[i].UserId==this.tabId){
                        arr.push(this.serviceLogList[i]);
                    }
                }
                return arr;
            }
        },
        //当前用户相关文档
        fileList(){
            if(this.tabId==0){
                return this.docList;
            }else{
                var arr=[];
                for (let i = 0; i < this.docList.length; i++) {
                    if(this.docList[i].UserId==this.tabId){
                        arr.push(this.docList[i]);
                    }
                }
                return arr;
            }
        },
        //当前用户的其他票据
        OtherAmountFileList(){
            if(this.tabId==0){
                return this.OtherFileList;
            }else{
                var arr=[];
                for (let i = 0; i < this.OtherFileList.length; i++) {
                    if(this.OtherFileList[i].UserId==this.tabId){
                        arr.push(this.OtherFileList[i]);
                    }
                }
                return arr;
            }
        },
        //当前用户住宿票据
        HousingAmountFileList(){
            if(this.tabId==0){
                return this.HousingFileList;
            }else{
                var arr=[];
                for (let i = 0; i < this.HousingFileList.length; i++) {
                    if(this.HousingFileList[i].UserId==this.tabId){
                        arr.push(this.HousingFileList[i]);
                    }
                }
                return arr;
            }
        },
        //当前用户交通票据
        TrafficAmountFileList(){
            if(this.tabId==0){
                return this.TrafficFileList;
            }else{
                var arr=[];
                for (let i = 0; i < this.TrafficFileList.length; i++) {
                    if(this.TrafficFileList[i].UserId==this.tabId){
                        arr.push(this.TrafficFileList[i]);
                    }
                }
                return arr;
            }
        },
        //当前用户加班票据
        OvertimeAmountFileList(){
            if(this.tabId==0){
                return this.OvertimeFileList;
            }else{
                var arr=[];
                for (let i = 0; i < this.OvertimeFileList.length; i++) {
                    if(this.OvertimeFileList[i].UserId==this.tabId){
                        arr.push(this.OvertimeFileList[i]);
                    }
                }
                return arr;
            }
        },
        //当前用户补助票据
        TicketAmountFileList(){
            if(this.tabId==0){
                return this.TicketFileList;
            }else{
                var arr=[];
                for (let i = 0; i < this.TicketFileList.length; i++) {
                    if(this.TicketFileList[i].UserId==this.tabId){
                        arr.push(this.TicketFileList[i]);
                    }
                }
                return arr;
            }
        },
        //当前用户的服务单
        reportFileList(){
            if(this.tabId==0){
                return this.serviceOrderList;
            }else{
                var arr=[];
                for (let i = 0; i < this.serviceOrderList.length; i++) {
                    if(this.serviceOrderList[i].UserId==this.tabId){
                        arr.push(this.serviceOrderList[i]);
                    }
                }
                return arr;
            }
        },
        reportContent(){
            var str='';
            if(!this.isSelf){
                str=this.serviceContent;
            }else{
                for (let i = 0; i < this.engineerReportList.length; i++) {
                    if(this.engineerReportList[i].UserId==this.tabId){
                        str=this.engineerReportList[i].ServiceContent;
                    }
                }
            }
            return str;
        }
    },
    watch: {
        baseInfo:{
            immediate: true,
            handler() {
                this.baseInfosJobType = this.baseInfo.JobType;
                this.baseInfosJobStep = this.baseInfo.JobStep;
            }
        },
        fileList(){
            this.$nextTick(()=>{
                this.$previewRefresh(); //图片必须预览刷新才可以点击放大 
            })
        },
        OtherAmountFileList(){
            this.$nextTick(()=>{
                this.$previewRefresh(); //图片必须预览刷新才可以点击放大 
            })
        },
        HousingAmountFileList(){
            this.$nextTick(()=>{
                this.$previewRefresh(); //图片必须预览刷新才可以点击放大 
            })
        },
        TrafficAmountFileList(){
            this.$nextTick(()=>{
                this.$previewRefresh(); //图片必须预览刷新才可以点击放大 
            })
        },
        OvertimeAmountFileList(){
            this.$nextTick(()=>{
                this.$previewRefresh(); //图片必须预览刷新才可以点击放大 
            })
        },
        TicketAmountFileList(){
            this.$nextTick(()=>{
                this.$previewRefresh(); //图片必须预览刷新才可以点击放大 
            })
        },
        reportFileList(){
            this.$nextTick(()=>{
                this.$previewRefresh(); //图片必须预览刷新才可以点击放大 
            })
        }
    },
    created() {
        this.jobNo=this.$route.query.jobNo;
        this.init();
    },
    methods: {
        init(){
            GetJobServiceReport({platform:'pcweb',jobNo:this.jobNo}).then(r=>{
                if(r.Result==1){
                    this.serviceLogList=r.Data.WorkLogList||[];
                    this.docList=r.Data.RefFileList||[];
                    this.serviceOrderList=r.Data.ReportFileList||[];
                    this.costInfo=r.Data.JobAmount;
                    // D --
                    this.addCostInfo = r.Data.JobAmount;
                    this.isEvaluate = r.Data.IsEvaluate;
                    this.IsExist = r.Data.JobAmount.IsExist
                    this.OtherFileList = r.Data.JobAmount.OtherAmountFileList||[];
                    this.HousingFileList = r.Data.JobAmount.HousingAmountFileList||[];
                    this.TrafficFileList = r.Data.JobAmount.TrafficAmountFileList||[];
                    this.OvertimeFileList = r.Data.JobAmount.OvertimeAmountFileList||[];
                    this.TicketFileList = r.Data.JobAmount.TicketFileList||[];

                    this.jobAmountVO = r.Data.EngineerServiceReportList|| [],   //每个工程师的费用明细
                    this.serviceContent=r.Data.ServiceContent;
                    this.engineerReportList=r.Data.EngineerServiceReportList || [];
                    this.isSelf=r.Data.IsSelfApplyOrder;
                    //筛选工程师姓名，填充tabhd
                    let obj={},arr=[];
                    for (let i = 0; i < this.serviceLogList.length; i++) {
                        if(!obj[this.serviceLogList[i].UserId]){
                            obj[this.serviceLogList[i].UserId]=this.serviceLogList[i].UserId;
                            let item={};
                            item['id']=this.serviceLogList[i].UserId;
                            item['name']=this.serviceLogList[i].UserName;
                            arr.push(item);
                        }
                        //时间如果是空字符，转成“--”
                        this.serviceLogList[i].GoTime=this.serviceLogList[i].GoTime==''?'--':this.serviceLogList[i].GoTime;
                        this.serviceLogList[i].WorkTime=this.serviceLogList[i].WorkTime==''?'--':this.serviceLogList[i].WorkTime;
                        this.serviceLogList[i].BackTime=this.serviceLogList[i].BackTime==''?'--':this.serviceLogList[i].BackTime;
                    }
                    this.tabHd.push(...arr);
                    if(this.isSelf){
                        this.tabHd.shift();
                        this.tabId=this.tabHd[0].id || 0;
                    }
                    this.$nextTick(()=>{
                        this.$previewRefresh(); //图片必须预览刷新才可以点击放大 
                    })
                }else{
                    this.$toast(r.Message);
                }
            })
        },
        tab(id,index){
            console.log(id)
            this.tabId=id;
            if(index != 0){
                this.costInfo = this.jobAmountVO[index-1];
            }else {
                this.costInfo = this.addCostInfo
            }
        },
        //行为举止评价
        behaviorEvaluate(data){
            this.behavior=data;
        },
        //服务评价
        serviceEvaluate(data){
            this.service=data;
        },
        //服务评价
        supaiServiceEvaluate(data){
            this.supaiService=data;
        },
        //技能水平评价
        skillEvaluate(data){
            this.skill=data;
        },
        //内部工单确认
        jobType8ConfirmReport(){
            this.$emit('confirmReport');
        },
        // 确认服务报告
        confirmReport(){
            this.$emit('afterEvaluate');
            // if(this.isEvaluate){
            //     // 是否追加 （追加付款）
            //     if(this.addCostInfo.DifferStatus==2) {
            //         this.$emit('pickConfirmPay',false)
            //     }else{
            //         this.$emit('showAdd')
            //     }
            // }else{
            //     this.showEvaluate=true;
            // }
            
        },
        //提交评价
        confirmEvaluate(){
            if(!this.skill){
                this.$toast('请评价技术能力！');
                return;
            }
            if(!this.behavior){
                this.$toast('请评价言行举止！');
                return;
            }
            if(!this.service){
                this.$toast('请评价服务完成质量！');
                return;
            }
            if(!this.supaiService){
                this.$toast('请评价速派对接服务！');
                return;
            }
            SubmitJobServiceCommend({
                JobNo:this.jobNo,
                UserCode:this.userInfo.UserCode,
                TechnicalLevel:this.skill,
                BehaviorLevel:this.behavior,
                ServiceQualityLevel:this.service,
                ButtjointLevel:this.supaiService,
                platform:'pcweb',
            }).then(r=>{
                this.showEvaluate=false;
                if(r.Result==1){
                    this.$emit('afterEvaluate');
                    // this.$emit('fadeInPwdDialogFun')
                    this.init();
                }else{
                    this.$toast(r.Message);
                }
            })
        }
    },
}
</script>
<style lang="scss">
.service-report{
    width: 840px;
    padding-top: 50px;
    padding-bottom: 80px;
    .btn-primary{
        width: 120px;
        height: 36px;
        background: #f75959;
        text-align: center;
        line-height: 36px;
        cursor: pointer;
        font-size: 14px;
        color: #fff;
        margin: 20px auto;
        &:active{
            background-color: #ff3838;
        }
    }
    .module-hd{
        font-size: 24px;
        color: #333;
        line-height: 1.2;
        font-weight: bold;
    }
    .sub-title{
        font-size: 18px;
        color: #333;
        line-height: 1.5;
        margin-top: 15px;
        margin-bottom: 10px;
    }
    .tab-hd{
        height: 48px;
        margin-bottom: 20px;
        border-bottom: 1px solid #e5e5e5;
        li{
            float: left;
            height: 48px;
            width: 120px;
            line-height: 45px;
            border: 1px solid #e5e5e5;
            text-align: center;
            font-size: 16px;
            color: #333;
            margin-left: -1px;
            cursor: pointer;
            position: relative;
            user-select: none;
            &.on{
                border-bottom-color: #fff;
            }
            &:before{
                content: '';
                position: absolute;
                left: 50%;
                top: -1px;
                z-index: 2;
                width: 0px;
                height: 2px;
                transform:translateX(-50%);
                background-color: #f75959;
            }
            &.on:before{
                width: 100%;
                transition: all 0.2s linear;
            }
        }
    }
    .label{
        float: left;
        font-size: 14px;
        color: #333;
        line-height: 24px;
        min-width: 70px;
        text-align: right;
    }
    .table-hd{
        overflow: hidden;
        margin-bottom: 10px;
    }
    .table-type{
        float: right;
        font-size: 14px;
        color: #333;
        line-height: 24px;
        span{
            cursor: pointer;
        }
        .on{
            color: #f75959;
        }
    }
    .table{
        width: 100%;
        font-size: 14px;
        border-collapse: collapse;
        background-color: #fff;
        margin-bottom: 30px;
        text-align: center;
        tr{
            border: 1px solid #e5e5e5;
            &:first-child{
                background-color: #f9f9f9;
            }
        }
        th{
            height: 48px;
            color: #999;
        }
        td{
            height: 48px;
            color: #333;
        }
    }
    .info-dl{
        margin-bottom: 10px;
        overflow: hidden;
        .value{
            float: left;
            max-width: 770px;
        }
    }
    .pic{
        display: inline-block;
        width: 80px;
        height: 80px;
        vertical-align: middle;
        margin-right: 20px;
        margin-bottom: 10px;
    }
    .report-desc{
        margin-bottom: 40px;
        font-size: 14px;
        color: #666;
        line-height: 24px;
        word-break: break-all;
    }
    .bill{
        margin-top: 20px;
        li{
            margin-bottom: 15px;
        }
        .value{
            float: right;
            max-width: 770px;
            font-size: 16px;
            word-break: break-all
        }
        .tax{
            color: #999;
        }
        .price{
            color: #ff3838;
        }
        .pic{
            margin-right: 0;
            margin-left: 20px;
        }
    }
    .remark>.label,
    .remark>.value{
        color: #999;
        font-size: 14px;
    }
    .cost-info{
        padding: 10px 20px;
        background-color: #f9f9f9;
        .item{
            overflow: hidden;
            color: #333;
        }
        .label{
            float: left;
            font-size: 14px;
            line-height: 30px;
            text-align: left;
        }
        .value{
            float: right;
            font-size: 16px;
            font-weight: 500;
            line-height: 30px;
        }
        .price{
            color: #ff3838;
        }
    }
    .total{
        text-align: right;
        margin-top: 10px;
        font-size: 16px;
        color: #333;
        .price{
            font-size: 24px;
            color: #ff3838;
        }
    }
    .form{
        padding: 30px 50px 0px;
        .form-item{
            margin-bottom: 20px;
        }
        .form-label{
            display: inline-block;
            width: 140px;
            line-height:24px;
            font-size: 14px;
            color: #666;
        }
        .stars{
            display: inline-block;
            .star-item{
                margin-right: 22px;
            }
        }
        .btn-primary{
            margin-top: 40px;
            margin-bottom: 0;
        }
    }
}
</style>